import React, { useMemo } from "react"
import { useOutletContext } from "react-router-dom"

import {
  TYPE_NONE,
  TYPE_HIDDEN,
  TYPE_STRING,
  TYPE_REDACTOR,
} from "@components/Form"
import { TemplateVariablesDropdown } from "@components/Templates"

const LABEL_SUBJECT = "Subject"
const LABEL_MESSAGE = "Message"
const LABEL_SUBJECT_PLACEHOLDER = "Notification Subject"


const useCustomTemplateInputs = (form, templateKey, shouldRender = false) => {
  const { projectTemplatesStore } = useOutletContext()
  const { getTemplateByKey } = projectTemplatesStore

  const template = getTemplateByKey(templateKey)

  return useMemo(() => {
    const { html, source, subject, variables } = template

    if (!shouldRender) {
      return [
        {
          name: "customSubjectTemplate",
          type: TYPE_NONE,
        },
        {
          name: "customSourceTemplate",
          type: TYPE_NONE,
        },
        {
          name: "customHtmlTemplate",
          type: TYPE_NONE,
        },
      ]
    }

    const tags = variables
      .map(variable => variable.split(":")[1])

    const appendVariable = variable => {
      const currentSubject = form.getFieldValue('customSubjectTemplate')
      const value = `${currentSubject} ${variable}`

      form.setFieldValue('customSubjectTemplate', value)
    }

    return [{
      name: "customSubjectTemplate",
      type: TYPE_STRING,
      label: LABEL_SUBJECT,
      placeholder: LABEL_SUBJECT_PLACEHOLDER,
      initialValue: subject,
      inputProps: {
        size: "large",
        suffix: (
          <TemplateVariablesDropdown
            variables={variables}
            appendVariable={appendVariable}
          />
        )
      }
    },
    {
      name: "customSourceTemplate",
      type: TYPE_REDACTOR,
      label: LABEL_MESSAGE,
      initialValue: source,
      inputProps: {
        emailTargetPath: 'customHtmlTemplate',
        options: {
          plugins: [
            'mergetag'
          ],
          mergetag: {
            items: tags
          }
        }
      }
    },
    {
      name: "customHtmlTemplate",
      initialValue: html,
      type: TYPE_HIDDEN,
    }]
  }, [
    form,
    template,
    shouldRender
  ])
}

export default useCustomTemplateInputs
